import { Card, Table, Row } from "antd";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MgmtService from "../../../app/service/mgmtService";
import { Button } from "../../../components";
import MgmtLayout from "../../../components/layouts/MgmtLayout";

export const MgmtPlates = () => {
    const [plates, setPlates] = useState([]);
    const [loading, setLoading] = useState(false);

    const mgmtService = new MgmtService();

    const columns = [
        {
            title: () => {
                return <div style={{ display:'flex', color: 'white', fontSize: '14px', fontWeight: 500, justifyContent:'center' }}>Cliente</div>
            },
            align:'center',
            dataIndex: 'clientName',
            key: 'clientName',
            size: 50,
        },
        {
            title: () => {
                return <div style={{ display:'flex', color: 'white', fontSize: '14px', fontWeight: 500, justifyContent:'center' }}>Placa</div>
            },
            align:'center',
            dataIndex: 'plate',
            key: 'plate',
            size: 150
        },
        {
            title: () => {
                return <div style={{ display:'flex', color: 'white', fontSize: '14px', fontWeight: 500, justifyContent:'center' }}>Descrição</div>
            },
            align:'center',
            dataIndex: 'description',
            key: 'description',
            size: 80,
            render: (text) => {
                if (text === 'lightingtower') {
                    return "Torre de Iluminação";
                } else if (text === "compressor") {
                    return "Compressor";
                } else if (text === "vehicle") {
                    return "Veículo";
                } else if (text === "electricGenerator") {
                    return "Gerador";
                } else {
                    return "";
                }

            }
        },
    ]

    useEffect(() => {
        setLoading(true);

        mgmtService.getPlates().then(res => {
            setPlates(res.data.data);
            setLoading(false);
        }).catch(err => {
            setLoading(false);
        });
    }, []);

    return (
        <MgmtLayout>
            <Card title='Placas' style={{ height: '80%' }}>
                <Row span={24} style={{ marginBottom: '15px' }}>

                    <Link to='/mgmt/plate/create'><Button style={{ margin: '5px' }}>+ Novo</Button></Link>

                    <Link to='/mgmt/plate/update'><Button style={{ margin: '5px' }}>+ Alterar Placa</Button></Link>
                </Row>

                <Table
                    size='small'
                    style={{ width: '100%', overflow: 'hidden' }}
                    columns={columns}
                    dataSource={plates}
                    loading={loading}
                />
            </Card>
        </MgmtLayout>
    );
}